import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AbsSwitchComponent } from './abs-switch.component';
import { AbsKeymapService } from '../abs-utilities/abs-keymap.service';

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [AbsSwitchComponent],
  exports: [AbsSwitchComponent],
  providers: [AbsKeymapService]
})
export class AbsSwitchModule { }
